
import { Component, Prop } from 'vue-property-decorator'
import { BaseUserResourceComponent } from '../base/BaseMixins'

@Component({inheritAttrs: false})
export default class UserAvatar extends BaseUserResourceComponent {
    @Prop({default: false}) readonly showAdmin !: boolean
}
